import { render, staticRenderFns } from "./mobileMenu.vue?vue&type=template&id=55904b2e"
import script from "./mobileMenu.vue?vue&type=script&lang=js"
export * from "./mobileMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports